import {
    ProxyChallenge,
    NonceChallenge,
    WebAuthnGetChallenge,
    WebAuthnCreateChallenge,
    OIDCChallenge,
    UICustomizationChallenge,
    NonceAttestation,
    WebAuthnCreateAttestation,
    WebAuthnGetAttestation,
    ChallengeType,
} from "../clients/slashid-api"

export type Challenge =
    | ProxyChallenge
    | NonceChallenge
    | WebAuthnGetChallenge
    | WebAuthnCreateChallenge
    | OIDCChallenge
    | UICustomizationChallenge

export type ChallengeSSR = NonceChallenge | ProxyChallenge

export function isNonceChallenge(challenge: Challenge): challenge is NonceChallenge {
    return challenge.type === ChallengeType.Nonce
}

export function isProxyChallenge(challenge: Challenge): challenge is ProxyChallenge {
    return challenge.type === ChallengeType.Proxy
}

export type Attestation = NonceAttestation | WebAuthnGetAttestation | WebAuthnCreateAttestation
